/* ==========================================================================
   Size charts made readable on phones (client, 7 Oct 2026: "explore a more user-friendly way to present the size
   charts while maintaining readability"), on the product page's size drawer and the size guide page.
   - [data-ivp-sz]: tabs between a product's charts (Regular / Tall / Garment, Men's / Women's)
   - [data-ivp-size-cards] (drawer) and [data-sg-chart] (size guide page): under 600 px the wide table gives way to
     size chips and one size's measurements as a list; "Compare all sizes" brings the whole table back
   - the product page highlights the chosen size in every chart (instead of a column fixed in the description)
   Reads the table as it is, so the page's own cm/in switch and "Find my size" result carry through (a
   MutationObserver re-reads it). Without this script the tables stay as they are.
   ========================================================================== */
(function () {
  'use strict';
  var d = document;
  var SIZE_RE = /^(xxs|xs|s|m|l|xl|xxl|xxxl|[2-9]xl)(-t)?$/;
  function qsa(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // "36 / 46 (XS)" -> "xs", "L" -> "l", "2XL-T" -> "2xl-t", "4-6-years" -> "4-6"
  function norm(s) {
    s = String(s || '').toLowerCase().trim();
    var p = s.match(/\(([a-z0-9-]+)\)/);
    if (p && SIZE_RE.test(p[1])) return p[1];
    return s.replace(/\s+/g, '').replace(/-?(yrs?|years?)$/, '');
  }
  function isSize(s) {
    var n = norm(s);
    if (SIZE_RE.test(n)) return true;
    if (/^\d{2}$/.test(n)) return +n >= 24 && +n <= 62;
    return /^\d{1,2}-\d{1,2}$/.test(n);
  }

  /* ---------- Read a table: sizes across the header row, or down the first column ---------- */
  function cellLabel(cell) {
    var how = cell.querySelector('.mx-how');
    var main = txt(cell);
    if (how) main = main.replace(txt(how), '').trim();
    return { main: main, how: how ? txt(how) : '' };
  }
  function read(table) {
    var rows = Array.prototype.slice.call(table.rows);
    if (rows.length < 2) return null;
    var head = Array.prototype.slice.call(rows[0].cells);
    var cols = [];
    head.forEach(function (c, i) { if (isSize(txt(c))) cols.push(i); });
    var m = { sizes: [], rows: rows };
    if (cols.length >= 2) {
      m.orient = 'cols';
      var labels = [];
      for (var i = 0; i < cols[0]; i++) labels.push(i);
      cols.forEach(function (ci) { m.sizes.push({ label: txt(head[ci]), key: norm(txt(head[ci])), col: ci }); });
      m.measures = rows.slice(1).map(function (tr) {
        var cells = Array.prototype.slice.call(tr.cells);
        var parts = labels.map(function (i) { return cells[i] ? cellLabel(cells[i]) : { main: '', how: '' }; });
        var main = parts.map(function (p) { return p.main; }).filter(function (s) { return s && !/^[-–—#]+$/.test(s); });
        // a one-letter key column ("A", "B") goes in front of the name
        var name = main.length > 1 && main[0].length <= 2 ? main[0] + ' · ' + main.slice(1).join(' ') : main.join(' ');
        return { name: name, how: parts.map(function (p) { return p.how; }).filter(Boolean).join(' '), cells: cells };
      });
    } else {
      var body = rows.slice(1);
      var hits = body.filter(function (tr) { return tr.cells[0] && isSize(txt(tr.cells[0])); }).length;
      if (hits < 2) return null;
      m.orient = 'rows';
      body.forEach(function (tr) { if (tr.cells[0]) m.sizes.push({ label: txt(tr.cells[0]), key: norm(txt(tr.cells[0])), row: tr }); });
      m.measures = head.slice(1).map(function (h, j) { var l = cellLabel(h); return { name: l.main, how: l.how, col: j + 1 }; });
    }
    return m.sizes.length >= 2 ? m : null;
  }
  // a body or garment measurement takes the unit after its value; other size systems (USA, Alpha) do not
  var MEASURE_RE = /chest|bust|waist|belly|hip|seat|thigh|knee|ankle|leg|inseam|rise|raise|sleeve|arm|shoulder|neck|length|height|hem|cuff|hand|palm|foot|calf/i;
  function values(m, s) {
    var out = [];
    m.measures.forEach(function (r) {
      var v = m.orient === 'cols' ? txt(r.cells[s.col]) : txt(s.row.cells[r.col]);
      if (!v || !r.name) return;
      out.push({ name: r.name.replace(/\s*\((cm|in|inch|inches)\)/i, '').replace(/,\s*$/, ''), how: r.how, v: v, measure: MEASURE_RE.test(r.name) });
    });
    return out;
  }
  function cellsOf(m, s) {
    if (m.orient === 'cols') return m.rows.map(function (tr) { return tr.cells[s.col]; }).filter(Boolean);
    return Array.prototype.slice.call(s.row.cells);
  }

  /* ---------- Units: the table's own label says cm or in; the drawer can switch cm -> in ---------- */
  function unitOf(holder, table) {
    var h = txt(table.rows[0]).toLowerCase();
    if (/\(in\)|inch/.test(h)) return 'in';
    if (/cm/.test(h)) return 'cm';
    return holder.getAttribute('data-unit') || '';
  }
  function toIn(v) { return v.replace(/\d+(?:[.,]\d+)?/g, function (n) { return (Math.round(parseFloat(n.replace(',', '.')) / 2.54 * 10) / 10).toString(); }); }

  /* ---------- The phone view ---------- */
  function chosenSize() {
    var c = d.querySelector('.ivp-opt--size input:checked');
    return c ? norm(c.value) : '';
  }
  function setup(holder) {
    var table = holder.querySelector('table');
    if (!table || holder._szc) return;
    var model = read(table);
    if (!model) return;
    var box = d.createElement('div');
    box.className = 'ivp-szc';
    var drawer = holder.hasAttribute('data-ivp-size-cards');
    box.innerHTML = '<div class="ivp-szc__head"><p class="ivp-szc__q">Pick a size</p>' +
      (drawer ? '<div class="ivp-szc__units" role="group" aria-label="Units" hidden><button type="button" data-u="cm" aria-pressed="true">cm</button><button type="button" data-u="in" aria-pressed="false">in</button></div>' : '') +
      '</div><div class="ivp-szc__chips" role="radiogroup" aria-label="Sizes"></div><dl class="ivp-szc__list" aria-live="polite"></dl>' +
      '<button type="button" class="ivp-szc__all" aria-expanded="false">Compare all sizes</button>';
    var wrap = table.parentElement === holder ? table : table.parentElement;
    wrap.classList.add('ivp-szc__table');
    holder.insertBefore(box, wrap);
    holder.classList.add('has-szc');
    var st = { model: model, key: '', unit: '', show: 'cm' };
    holder._szc = st;

    function pick() {
      var keys = st.model.sizes.map(function (s) { return s.key; });
      var want = drawer ? chosenSize() : '';
      if (want && keys.indexOf(want) > -1) return want;
      var match = table.querySelector('.is-match');
      if (match) {
        var hit = st.model.sizes.filter(function (s) { return cellsOf(st.model, s).indexOf(match) > -1; })[0];
        if (hit) return hit.key;
      }
      if (st.key && keys.indexOf(st.key) > -1) return st.key;
      return keys[0];
    }
    // a size tapped on a chip (st.manual) stays until the shopper chooses a size on the page or the finder picks one
    function render() {
      st.model = read(table) || st.model;
      st.unit = unitOf(holder, table);
      var keys = st.model.sizes.map(function (s) { return s.key; });
      if (!(st.manual && keys.indexOf(st.key) > -1)) st.key = pick();
      var units = box.querySelector('.ivp-szc__units');
      if (units) units.hidden = st.unit !== 'cm';
      box.querySelector('.ivp-szc__chips').innerHTML = st.model.sizes.map(function (s) {
        return '<button type="button" role="radio" aria-checked="' + (s.key === st.key) + '" data-k="' + esc(s.key) + '">' + esc(s.label) + '</button>';
      }).join('');
      var cur = st.model.sizes.filter(function (s) { return s.key === st.key; })[0];
      var conv = st.unit === 'cm' && st.show === 'in';
      var unit = conv ? 'in' : st.unit;
      box.querySelector('.ivp-szc__list').innerHTML = cur ? values(st.model, cur).map(function (r) {
        var v = conv && r.measure ? toIn(r.v) : r.v;
        var num = r.measure && /\d/.test(v) && !/[a-z]{3,}/i.test(v);
        return '<div><dt>' + esc(r.name) + (r.how ? '<small>' + esc(r.how) + '</small>' : '') + '</dt><dd>' + esc(v) + (num && unit ? ' <small>' + unit + '</small>' : '') + '</dd></div>';
      }).join('') : '';
    }
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-k]');
      if (chip) { st.key = chip.getAttribute('data-k'); st.manual = true; render(); return; }
      var u = e.target.closest('[data-u]');
      if (u) {
        st.show = u.getAttribute('data-u');
        Array.prototype.forEach.call(u.parentNode.children, function (b) { b.setAttribute('aria-pressed', b === u ? 'true' : 'false'); });
        render();
        return;
      }
      var all = e.target.closest('.ivp-szc__all');
      if (all) {
        var open = holder.classList.toggle('is-all');
        all.setAttribute('aria-expanded', open ? 'true' : 'false');
        all.textContent = open ? 'Show one size at a time' : 'Compare all sizes';
      }
    });
    st.render = function () { st.manual = false; render(); };
    render();
    // the page's cm/in switch rewrites the cells (keep the tapped size); "Find my size" marks a size (follow it)
    var t = 0;
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        if (muts.some(function (mu) { return mu.type === 'attributes' && mu.target.classList && mu.target.classList.contains('is-match'); })) st.manual = false;
        cancelAnimationFrame(t);
        t = requestAnimationFrame(render);
      }).observe(table, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ---------- Product page: highlight the chosen size in every chart ---------- */
  function highlight() {
    var key = chosenSize();
    qsa('[data-ivp-size-cards]').forEach(function (holder) {
      var table = holder.querySelector('table');
      if (!table) return;
      qsa('.is-sel', table).forEach(function (c) { c.classList.remove('is-sel'); });
      var m = read(table);
      if (!m || !key) return;
      var s = m.sizes.filter(function (x) { return x.key === key; })[0];
      if (s) cellsOf(m, s).forEach(function (c) { c.classList.add('is-sel'); });
      if (holder._szc && holder._szc.render) holder._szc.render();
    });
  }

  /* ---------- Tabs between a product's charts ---------- */
  function tabs(box) {
    var btns = qsa('[data-ivp-sz-tab]', box);
    var panels = qsa('[data-ivp-sz-panel]', box);
    function show(i) {
      btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-ivp-sz-tab') === i ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-ivp-sz-panel') !== i; });
    }
    if (btns.length) {
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-ivp-sz-tab]'); if (b) show(b.getAttribute('data-ivp-sz-tab')); });
      show(btns[0].getAttribute('data-ivp-sz-tab'));
    } else {
      panels.forEach(function (p, i) { p.hidden = i > 0; });
    }
  }

  function init() {
    qsa('[data-ivp-sz]').forEach(tabs);
    qsa('[data-ivp-size-cards], [data-sg-chart]').forEach(setup);
    highlight();
    d.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.ivp-opt--size')) highlight(); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
